<template>
  <div class="search">
    <form>
      <div>
        <span class="initial-header md-display-1">{{ $t('HOME.INITIAL_HEADER') }}</span>
        <p class="search-package-text md-subheading">{{ $t('HOME.INITIAL_DESCRIPTION') }}</p>
      </div>
      <SearchInput :country="defaultCountryCode" @search="onSearch"></SearchInput>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { DEFAULT_COUNTRY } from '@/configs/constants'
import SearchInput from '@/components/SearchInput'

export default {
  name: 'Search',
  components: {
    SearchInput
  },
  data () {
    return {
      defaultCountryCode: DEFAULT_COUNTRY.code
    }
  },
  computed: {
    ...mapState('location', [
      'language'
    ])
  },
  methods: {
    onSearch ({ trackingNumber, country }) {
      this.$router.push({
        name: 'package-tracker',
        params: { country, language: this.language, trackingNumber }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.search
  background-color: rgba(255, 255, 255, 0.7)
  border-radius: 10px
  padding: 25px
  position: absolute
  z-index: 10
  margin: 4% 0 0 4%
  width: 40%
  @media (max-width: 1024px)
    width: 60%
  @media (max-width: 768px)
    width: 84%

.initial-header
  font-size: 2.2em
  @media (max-width: 768px)
    font-size: 2em
.search-package-text
  font-size: 1.2em
  @media (max-width: 768px)
    font-size: 1em
</style>
